export default __webpack_public_path__ + "static/media/a_wdt_c_1_2.d8a8c657.mp3";